import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "../lib/supabaseClient";

// Survives a refresh on the "choose a new password" screen.
const RECOVERY_KEY = "hazumu:recovering";

const readRecovery = () => {
  try {
    return sessionStorage.getItem(RECOVERY_KEY) === "1";
  } catch {
    return false;
  }
};

const writeRecovery = (on: boolean) => {
  try {
    if (on) sessionStorage.setItem(RECOVERY_KEY, "1");
    else sessionStorage.removeItem(RECOVERY_KEY);
  } catch {
    // Storage can be blocked; recovery then just lasts until a refresh.
  }
};

export const useAuthSession = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  // True after a password reset link signs someone in, until they've chosen
  // a new password.
  const [recovering, setRecovering] = useState(readRecovery);

  useEffect(() => {
    void supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, nextSession) => {
      if (event === "PASSWORD_RECOVERY") {
        writeRecovery(true);
        setRecovering(true);
      }
      if (event === "SIGNED_OUT") {
        writeRecovery(false);
        setRecovering(false);
      }
      setSession(nextSession);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const endRecovery = () => {
    writeRecovery(false);
    setRecovering(false);
  };

  return { session, loading, recovering, endRecovery };
};
